import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import { SERVICE_NAME } from "@zapier/utils";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { ManagedConnectionSource } from "./managedConnectionSource";

export function useEmitManagedConnectionCreateClickedEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (source: ManagedConnectionSource) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ManagedConnectionCreateClicked,
        optionSelected: source,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
